// Libraries
import { NgModule } from '@angular/core';
import { CommonModule }   from '@angular/common';
import {
  ReactiveFormsModule,
  FormsModule
} from '@angular/forms';
import { LocalStorageModule } from 'angular-2-local-storage';
import { MyDatePickerModule } from 'mydatepicker';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { Ng2CompleterModule } from 'ng2-completer';
import { ChartsModule } from 'ng2-charts';

// Woopa modules
import {
  ConfirmationPopoverModule,
  PaginationModule,
  MonthYearPickerModule
} from '../../woopa-ui/';

// Directives
import { OnlyNumberDirective } from '../../woopa-ui/forms';

// Pipes
import { ObjectTypePipe } from './pipes/object-type.pipe';
import { UserRolePipe } from './pipes/user-role.pipe';
import { PositionExtraPipe } from './pipes/position-extra.pipe';
import { MonthYearDatePipe } from './pipes/month-year-date.pipe';
import { CapitalizePipe } from './pipes/capitalize.pipe';
import { DateFormatPipe } from './pipes/date-format.pipe';

// Components
import { ReviewResultComponent } from './components/review-result.component';
import { QuestionResultComponent } from './components/question-result.component';
import { PositionStatusComponent } from './components/position-status.component';
import { ExtinguisherStatusComponent } from './components/extinguisher-status.component';
import { QRModalComponent } from './components/qr-modal/qr-modal.component';
import { ExtinguisherChargesComponent } from './../+extinguishers/extinguisher-charges.component';
import { RepairSetStatusComponent } from './components/repair-set-status.component';
import { RepairEntryStatusComponent } from './components/repair-entry-status.component';

// Services
import { QRService } from './services/qr.service';

export const components = [
  ReviewResultComponent,
  QuestionResultComponent,
  PositionStatusComponent,
  ExtinguisherStatusComponent,
  ExtinguisherChargesComponent,
  QRModalComponent,
  RepairSetStatusComponent,
  RepairEntryStatusComponent
];

export const pipes = [
  ObjectTypePipe,
  UserRolePipe,
  PositionExtraPipe,
  MonthYearDatePipe,
  CapitalizePipe,
  DateFormatPipe
];

/**
 * `SharedModule` is where you will declare all your shared pipes, directives, and components.
 * Also you you can export commonly used modules like CommonModule and FormsModule.
 * Other modules will be using the module.
 */
@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    LocalStorageModule.withConfig({
      prefix: 'she',
      storageType: 'localStorage'
    }),
    ConfirmationPopoverModule.forRoot({
      confirmButtonType: 'danger' // set defaults here
    }),
    MyDatePickerModule,
    NgbModule.forRoot()
  ],
  declarations: [
    ...components,
    ...pipes,
    OnlyNumberDirective
  ],
  providers: [
    QRService
  ],
  exports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    ConfirmationPopoverModule,
    PaginationModule,
    MyDatePickerModule,
    ...components,
    ...pipes,
    MonthYearPickerModule,
    OnlyNumberDirective,
    ObjectTypePipe,
    Ng2CompleterModule,
    ChartsModule
  ]
})
export class SharedModule {}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/admin/shared/shared.module.ts